import { NoteTypes } from '../../domain/note';
import { KeyValuePairArray } from '../../KeyValuePair';

export interface INoteAddRequest {
    ID: number;
    Note: string;
    Sticky: boolean;
    RequestReview: boolean;
    AdminID: number;
    MemberID: number;
    NoteTypeList: KeyValuePairArray<NoteTypes, number>;
}

export class NoteAddRequest  implements INoteAddRequest {

    ID: number;
    Note: string;
    Sticky: boolean;
    RequestReview: boolean;
    AdminID: number;
    MemberID: number;
    NoteTypeList: KeyValuePairArray<NoteTypes, number>;

}
